import React, { useState } from "react";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";

const PasswordField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  icon: Icon,
  error,
  required,
  autoComplete,
  labelAction,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex flex-col gap-1.5">
      {(label || labelAction) && (
        <div className="flex items-center justify-between gap-3">
          {label && (
            <label htmlFor={id} className="text-[12.5px] font-medium text-text_secondary tracking-wide">
              {label}
              {required && <span className="text-danger ml-0.5"> *</span>}
            </label>
          )}
          {labelAction}
        </div>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-text_muted pointer-events-none">
            <Icon size={15} />
          </div>
        )}
        <input
          id={id}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          className={`w-full rounded border bg-surface_alt py-[11px] pr-10 text-sm text-text_primary placeholder:text-text_muted outline-none transition-all duration-150
            focus:bg-surface focus:ring-2 focus:ring-primary/[0.12] focus:border-primary/40
            ${Icon ? "pl-[2.375rem]" : "pl-3.5"}
            ${
              error
                ? "border-danger/60 bg-danger_bg/40 focus:ring-danger/20 focus:border-danger"
                : "border-border hover:border-border_strong"
            }`}
        />
        <button
          type="button"
          onClick={() => setShowPassword((p) => !p)}
          tabIndex={-1}
          aria-label={showPassword ? "Hide password" : "Show password"}
          className="absolute right-3.5 top-1/2 -translate-y-1/2 text-text_muted hover:text-text_secondary transition-colors"
        >
          {showPassword ? <RiEyeOffLine size={15} /> : <RiEyeLine size={15} />}
        </button>
      </div>
      {error && (
        <p className="text-[11.5px] text-danger">{error}</p>
      )}
    </div>
  );
};

export default PasswordField;
